export const setting = state => key => state.settings[key] ? state.settings[key] : null
export const permissions = state => key => state.settings.permissions[key] ? state.settings.permissions[key] : null
export const areas = state => state.settings.areas.map(area => `ar${area}`)
export const roles = state => { return state.settings.roles ? state.settings.roles.map(role => role) : [] }
export const lang = state => state.settings['lang'] ? state.settings['lang'] : 'en'
export const token = state => state.token

// shiseido data
export const dataready = state => state.options.fullyLoaded && Object.keys(state.projects)
export const projects = state => state.indexes.map(id => state.projects[id]) || []
export const options = state => state.options
export const option = state => (name, id) => state.options[name].filter(o => o.id === id)
export const optionId = state => (name, value) => {
	const prop = state.options[name] ? state.options[name].find(o => o.label === value) : null
	return prop ? prop.id : null
}
export const filterOptions = state => key => state.options[key] ? state.options[key] : []
export const project = state => id => state.projects[id]
export const projectProp = state => (id, key) => state.projects[id][key]
export const countries = state => state.options.country ? state.options.country.filter(c => c.lat && c.lon) : []
export const suppliers = state => {
	const projects = state.indexes.map(id => state.projects[id]) || []
	return [...new Set(projects.map(p => p.supplier))]
}
export const projectsFileDownload = state => state.projectsFile.length ? state.projectsFile : false
/* ZONES */
export const supplierManufacturers = state => array => state.options.supplierManufacturer.filter(supplier => array.includes(supplier.id))
/* /ZONES */
export const notificationToken = state => state.notificationsToken
export const notifications = state => state.notifications
export const notification = state => id => state.notifications[id]
export const notificationsCount = state => state.notifications ? state.notifications.length : 0
export const notificationsUnread = state => state.notifications.filter(notif => !notif.isRead) || []
export const notificationsUnreadCount = state => state.notifications.filter(notif => !notif.isRead).length || 0

// project keys
export const brand = state => id => state.options.brands.find(b => b.id === id)
/* ZONES */
export const zone = state => id => state.options.zone.find(z => z.countries.find(c => {
	if (`cn${c}` === id) {
		return z.supplierManufacturer
	}
}))
/* /ZONES */
export const distributionChannel = state => id => state.options.distributionChannel.find(dc => dc.id === id)
export const area = state => id => state.options.area.find(a => a.id === id)
export const country = state => id => state.options.country.find(c => c.id === id)
export const storeType = state => id => state.options.storeType.find(s => s.id === id)
export const storeLevel = state => id => state.options.storeLevel.find(l => l.id === id)
export const openRefurbish = state => id => state.options.openRefurbish.find(o => o.id === id)
export const personalizationType = state => id => state.options.personalizationType.find(p => p.id === id)
export const furnitureType = state => id => state.options.furnitureType.find(f => f.id === id)
export const projectStatus = state => id => state.options.projectStatus.find(s => s.id === id)
export const projectType = state => id => state.options.projectType.find(pt => pt.id === id)
export const supplierManufacturer = state => id => state.options.supplierManufacturer.find(s => s.id === id)
export const notificationType = state => id => state.options.notifications.find(n => n.id === id)

// Dashboard
export const dashboard = state => state.dashboard



// WEBPACK FOOTER //
// ./src/store/getters.js